import Button from '@ui/Button';
import React from 'react';
import Typography from '@ui/Typography';
import BannerEditor from '@ui/BannerEditor';
import getQualifiedImageUrl from '@utils/imageUrlProcessor';
import { MdEditSquare } from 'react-icons/md';
import { useFilePicker } from 'use-file-picker';
import StyledButtonNew from '@/components/Styled/StyledButtonNew';
import useBannerFileSelectorStore from '@/components/store/bannerFileSelectorSlice';
import { DEFAULT_USER_BANNER_IMAGE } from '@/constants/neki.constant';
const pica = require('pica/dist/pica.min')();

function BannerEditStep(props) {
  const { bannerImage, onSubmit, saving, deleteBanner } = props;

  const profileType = useBannerFileSelectorStore((state) => state.profileType);

  const [editor, setEditor] = React.useState(null);
  const setEditorRef = (e) => setEditor(e);

  const [newBannerImage, setNewBannerImage] = React.useState(null);
  const [isUploaded, setIsUploaded] = React.useState(false);
  const [disableSlider, setDisableSlider] = React.useState(
    DEFAULT_USER_BANNER_IMAGE === bannerImage,
  );

  const [openFileSelector, { filesContent, loading, errors: fileErrors }] =
    useFilePicker({
      readAs: 'DataURL',
      accept: 'image/*',
      multiple: false,
      maxFileSize: 5, // in megabytes
    });

  const showFileSelector = () => {
    openFileSelector();
  };

  React.useEffect(() => {
    if (filesContent && filesContent[0]) {
      setDisableSlider(false);
      setNewBannerImage(filesContent[0].content);
      setIsUploaded(true);
    }
  }, [filesContent]);

  const handleSave = async () => {
    if (editor) {
      // const canvas = editor.getImageScaledToCanvas();

      // canvas.toBlob(
      //   (blob) => {
      //     const editedImage = new File([blob], 'edited-image.jpg', {
      //       type: 'image/jpeg',
      //     });
      //     handleImageSubmit(editedImage);
      //   },
      //   'image/jpeg',
      //   0.9,
      // );

      // const img = editor.getImage();
      // var offScreenCanvas = document.createElement('canvas');
      // // make sure the aspect ratio for your offScreenCanvas matches the aspect ratio
      // // of your AvatarEditor
      // offScreenCanvas.width = 1170;
      // offScreenCanvas.height = 292.5;

      // const picaCanvas = await pica.resize(img, offScreenCanvas);
      // // const editedImage = picaCanvas.toBlob(
      // //   (blob) => URL.createObjectURL(blob),
      // //   'image/jpeg',
      // //   0.9,
      // // );
      // picaCanvas.toBlob(
      //   async (blob) => {
      //     const editedImage = new File([blob], 'edited-image.jpg', {
      //       type: 'image/jpeg',
      //     });
      //     console.log('edited image: ', editedImage);

      //     await handleImageSubmit(editedImage);
      //   },
      //   'image/jpeg',
      //   0.9,
      // );
      const img = editor.getImage();
      const originalWidth = img.width;
      const originalHeight = img.height;

      const maxWidth = 1170;
      const maxHeight = 292.5;

      const widthRatio = maxWidth / originalWidth;
      const heightRatio = maxHeight / originalHeight;

      const scaleFactor = Math.min(widthRatio, heightRatio);

      const offScreenCanvas = document.createElement('canvas');
      offScreenCanvas.width = originalWidth * scaleFactor;
      offScreenCanvas.height = originalHeight * scaleFactor;

      const picaCanvas = await pica.resize(img, offScreenCanvas);
      picaCanvas.toBlob(
        async (blob) => {
          const editedFile = new File([blob], 'edited-image.jpg', {
            type: 'image/jpeg',
          });
          await handleImageSubmit(editedFile);
        },
        'image/jpeg',
        0.9,
      );
    }
  };

  const handleImageSubmit = (file) => {
    if (file) {
      onSubmit({
        bannerImage: Object.assign(file, {
          preview: URL.createObjectURL(file),
        }),
      });
    }
  };

  return (
    <div className="flex w-full flex-1 flex-col gap-12">
      <Typography variant="dialogtitle">Edit Banner Image</Typography>
      <div className="flex flex-col gap-6">
        {bannerImage !== null || isUploaded ? (
          <BannerEditor
            setIsUploaded={setIsUploaded}
            bannerImage={getQualifiedImageUrl(bannerImage)}
            newBannerImage={newBannerImage}
            setEditorRef={setEditorRef}
            disableSlider={disableSlider}
          />
        ) : (
          <div className="relative flex flex-col gap-4">
            <div className="aspect-[4] w-full">
              <div className="h-full w-full bg-primary-light-1"></div>
              <div className="absolute right-[6px] top-1">
                <Button
                  variant="icon"
                  onClick={showFileSelector}
                  className="bg-white">
                  <MdEditSquare className="h-6 w-6 text-primary" />
                </Button>
              </div>
            </div>
          </div>
        )}

        <div className="flex-rows flex justify-between gap-4">
          <div className="flex-flow-col">
            <Button
              variant="outlined"
              color="primary"
              onClick={showFileSelector}
              type="button">
              Upload Image
            </Button>

            {profileType === 'user' && (
              <Button
                className="ml-2"
                variant="filled"
                color="primary"
                onClick={deleteBanner}
                type="button">
                Use default banner
              </Button>
            )}
          </div>

          {/* {isUploaded ? (
            <div className="flex-flow-col">
              <StyledButtonNew
                variant="filled"
                color="primary"
                type="submit"
                loading={saving}
                onClick={handleSave}>
                Save
              </StyledButtonNew>
            </div>
          ) : (
            <div className="flex-flow-col">
              <StyledButtonNew
                disabled
                variant="outlined"
                color="primary"
                type="submit"
                loading={saving}>
                Save
              </StyledButtonNew>
            </div>
          )} */}
          <div className="flex-flow-col">
            <StyledButtonNew
              variant="filled"
              color="primary"
              type="submit"
              loading={saving}
              onClick={handleSave}>
              Save
            </StyledButtonNew>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BannerEditStep;
